import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

import { useDraggable } from '@vueuse/core'
import { ModalProps } from 'ant-design-vue'
import { ref, watch, watchEffect, computed, CSSProperties, reactive, onMounted } from 'vue'

export interface ModalProPorps extends ModalProps {
  label: string,
  openConfirmLoading?: boolean,
  cancel?: () => void
}

export interface ModalOkProps {
  confirmed: () => void
  confirmStart: () => void
}

interface StateProps {
  confirmLoading: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    label: {},
    openConfirmLoading: { type: Boolean },
    cancel: { type: Function },
    prefixCls: {},
    visible: { type: Boolean },
    open: { type: Boolean },
    confirmLoading: { type: Boolean },
    title: {},
    closable: { type: Boolean },
    closeIcon: {},
    onOk: { type: Function },
    onCancel: { type: Function },
    "onUpdate:visible": { type: Function },
    onChange: { type: Function },
    afterClose: { type: Function },
    centered: { type: Boolean },
    width: {},
    footer: {},
    okText: {},
    okType: {},
    cancelText: {},
    icon: {},
    maskClosable: { type: Boolean },
    forceRender: { type: Boolean },
    okButtonProps: {},
    cancelButtonProps: {},
    destroyOnClose: { type: Boolean },
    wrapClassName: {},
    maskTransitionName: {},
    transitionName: {},
    getContainer: { type: [String, Boolean, Function] },
    zIndex: {},
    bodyStyle: {},
    maskStyle: {},
    mask: { type: Boolean },
    keyboard: { type: Boolean },
    wrapProps: {},
    focusTriggerAfterClose: { type: Boolean },
    modalRender: { type: Function },
    mousePosition: {}
  },
  emits: ["close", "ok"],
  setup(__props: any, { emit }) {

const props = __props;





const state = reactive<Partial<StateProps>>({})

const close = () => emit('close')

const handleOk = async () => {
  console.log('modal-pro：-----ok')

  emit('ok', {
    confirmStart: () => state.confirmLoading = true,
    confirmed: () => state.confirmLoading = false
  })
}

//  拖拽相关的代码
const modalTitleRef = ref()

const { x, y, isDragging } = useDraggable(modalTitleRef)

const startX = ref<number>(0)
const startY = ref<number>(0)
const startedDrag = ref(false)
const transformX = ref(0)
const transformY = ref(0)
const preTransformX = ref(0)
const preTransformY = ref(0)
const dragRect = ref({ left: 0, right: 0, top: 0, bottom: 0 })

watch([x, y], () => {
  if (!startedDrag.value) {
    startX.value = x.value
    startY.value = y.value
    const bodyRect = document.body.getBoundingClientRect()
    const titleRect = modalTitleRef.value.getBoundingClientRect()
    dragRect.value.right = bodyRect.width - titleRect.width
    dragRect.value.bottom = bodyRect.height - titleRect.height
    preTransformX.value = transformX.value
    preTransformY.value = transformY.value
  }
  startedDrag.value = true
})

watch(isDragging, () => {
  if (!isDragging) {
    startedDrag.value = false
  }
})

watchEffect(() => {
  if (startedDrag.value) {
    transformX.value =
          preTransformX.value +
          Math.min(Math.max(dragRect.value.left, x.value), dragRect.value.right) -
          startX.value
    transformY.value =
          preTransformY.value +
          Math.min(Math.max(dragRect.value.top, y.value), dragRect.value.bottom) -
          startY.value
  }
})

const transformStyle = computed<CSSProperties>(() => {
  return {
    transform: `translate(${transformX.value}px, ${transformY.value}px)`
  }
})
//  拖拽相关的代码


return (_ctx: any,_cache: any) => {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, _mergeProps({
    ref: "modalRef",
    "wrap-style": { overflow: 'hidden' },
    onOk: handleOk,
    onCancel: close,
    closable: false
  }, {
      cancelText: '取消',
      okText: '确定',
      ...props
    }, {
    confirmLoading: state.confirmLoading
  }), {
    title: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "modalTitleRef",
        ref: modalTitleRef,
        style: {"width":"100%","cursor":"move"}
      }, _toDisplayString(props.label || 'model'), 513)
    ]),
    modalRender: _withCtx(({ originVNode }) => [
      _createElementVNode("div", {
        style: _normalizeStyle(transformStyle.value)
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(originVNode)))
      ], 4)
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["confirmLoading"]))
}
}

})